import React from 'react';
import PageNotAccessibleImage from '../../assets/svg/pageNotAccessible.svg';
export default function SingleTabModal({ onUseHere, onCloseTab }) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-md p-6 rounded-lg text-center w-[90%] md:w-[40%]">
        <h1 className="text-xl font-semibold mb-4">Dear User</h1>
        <p className="text-gray-700  mb-6">This project is already open in another tab.</p>
        <img
          src={PageNotAccessibleImage}
          alt="Page Not Accessible"
          className="w-[100%] mx-auto mb-6 sm:w-[60%]"
        />
      </div>
    </div>
  );
}
